import {
	Component,
	OnInit,
	HostBinding,
	Input,
	Output,
	EventEmitter,
	ViewEncapsulation,
	ChangeDetectionStrategy
} from "@angular/core";
import * as model from "../datatable.models";
import { Column } from "../Column";
import { IdService } from "../../shared/services/id.service";

@Component({
	selector: "rbc-datatable-advanced-searcher",
	templateUrl: "./datatable-advanced-searcher.component.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatatableAdvancedSearcherComponent {
	@Input() id: string;
	@Input() columnIndex: number;
	@Input() column: Column;
	@Input() locale = model.Locale;

	@Output()
	onAdvancedSearchObjectUpdate = new EventEmitter();
	advancedSearchTerm = "";

	_uid;

	constructor(private idService: IdService) {
		this._uid = this.idService.generate();
	}

	idGen() {
		return typeof this.id !== "undefined"
			? this.id
			: "rbc-datatable-advanced-searcher-" + this._uid;
	}

	// Called when Advanced search term changes
	$_AdvancedSearch_inputUpdate(value) {
		this.onAdvancedSearchObjectUpdate.emit({
			column: this.column,
			value: value
		});
	}
}
